export default "__VITE_ASSET__x_TetpnP__"